import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import { Scrollbars } from 'react-custom-scrollbars-2';
import styleClasses from '../../Header/Header.module.scss';
import UpsellItemCard from './UpsellItemCard';
import SkeltonLoader from '../../SkeltonLoader/SkeltonLoader';
import SkeletonLoaderForHeadings from '../../SkeltonLoader/SkeletonLoaderForHeadings';
interface IUpselItemList {
  data: any;
  cart: any;
  fetchUpsell: () => void;
  isFetchingUpsell: boolean;
  syncCart: () => any;
}

const UpsellItemsLists: React.FC<IUpselItemList> = (props) => {
  const { data, isFetchingUpsell } = props;

  const [showUpsell, setShowUpsell] = useState(true);

  useEffect(() => {
    if (isFetchingUpsell) return;
    if (data?.length <= 0) {
      setShowUpsell(false);
    } else {
      setShowUpsell(true);
    }
  }, [isFetchingUpsell, data]);

  return (
    showUpsell && (
      <React.Fragment>
        <div className={styleClasses.other_products_wrap}>
          <h4 className="f-s22 f-sm-s16 font-Cls lh-normal ls-normal mb-3">
            {data?.length > 0 ? data[0].header : <SkeletonLoaderForHeadings/>} 
          </h4>
          {isFetchingUpsell ? (
            <div className="d-flex justify-content-center">
              <SkeltonLoader />
              <SkeltonLoader />
              <SkeltonLoader />
            </div>
          ) : (
            <Row className={styleClasses.suggestion_row + ' flex-nowrap pt-1'}>
              <Scrollbars
                className={styleClasses.other_products_Scrollbar + ' mb-mb-4'}
                renderThumbHorizontal={(props) => (
                  <div {...props} className={styleClasses.Scrollbar_thumb} />
                )}
                renderView={(props) => (
                  <div {...props} className={styleClasses.Scrollbar_view} />
                )}
              >
                {data?.map((item, index: number) => (
                  <React.Fragment key={item?.id}>
                    <UpsellItemCard
                      key={item?.id}
                      upSellItem={item}
                      btnText={'Add'}                  
                    />
                  </React.Fragment>
                ))}
              </Scrollbars>
            </Row>
          )}
        </div>
        <hr className="shadow-divider mb-4 border-0" />
      </React.Fragment>
    )
  );
};

export default UpsellItemsLists;
